import { render, staticRenderFns } from "./FolderAndResourceElement.vue?vue&type=template&id=7d924bec&scoped=true"
import script from "./FolderAndResourceElement.vue?vue&type=script&lang=js"
export * from "./FolderAndResourceElement.vue?vue&type=script&lang=js"
import style0 from "./FolderAndResourceElement.vue?vue&type=style&index=0&id=7d924bec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d924bec",
  null
  
)

export default component.exports